// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_hy-0";
export var fileCarousel = "_hy-2";
export var removeFileButton = "_hy-1";